import variables from '@/styles/element-variables.scss'
import defaultSettings from '@/settings'

const { showSettings, tagsView } = defaultSettings

const state = {
  theme: variables.theme,
  showSettings: showSettings,
  tagsView: tagsView,
  themeOptions: {
    blue: {
      "mainBg": "#F3F8FD", "siderBar": "#2e43ae", "siderBarFontC": "#adbbff", "lableC": "#0e2e5f", "loginBg": "#7199EF"
    },
    red: {
      "mainBg": "#F8F5F5", "siderBar": "#CC1818", "siderBarFontC": "#FFD1D1", "lableC": "#BF2525", "loginBg": "#D96767"
    },
    green: {
      "mainBg": "#F2F9F7", "siderBar": "#0A5F45", "siderBarFontC": "#A1E6D6", "lableC": "#0C825D", "loginBg": "#82BBAE"
    }
  }
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js